// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-60 {
  margin-top: 60px;
}

.break-title {
  word-wrap: break-word !important;
  font-size: 13px !important;
}
.footer-modal {
  flex: 0 0 auto;
}
::ng-deep mat-dialog-container {
  /* overflow-y: hidden !important */
  
}
::ng-deep .modal-media {
  position: relative !important;
  /* overflow-y: auto !important */
  ;
}

.modal-media {
  position: relative !important;
  overflow-y: auto !important
  ;
}

`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-folders/manage-media/manage-media.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;;AAEpC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;;AAElC;;AAEA;EACE,6BAA6B;EAC7B;EACA;AACF","sourcesContent":[".mt-60 {\r\n  margin-top: 60px;\r\n}\r\n\r\n.break-title {\r\n  word-wrap: break-word !important;\r\n  font-size: 13px !important;\r\n}\r\n.footer-modal {\r\n  flex: 0 0 auto;\r\n}\r\n::ng-deep mat-dialog-container {\r\n  /* overflow-y: hidden !important */\r\n  \r\n}\r\n::ng-deep .modal-media {\r\n  position: relative !important;\r\n  /* overflow-y: auto !important */\r\n  ;\r\n}\r\n\r\n.modal-media {\r\n  position: relative !important;\r\n  overflow-y: auto !important\r\n  ;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
